import { getEnvironmentVariable } from "@utils/shared.environment.utils";
import { EndSessionRequest, LogLevel, PopupRequest } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

export const msalConfig = {
    auth: {
        clientId: getEnvironmentVariable('VITE_MSAL_CLIENTID'),
        authority: getEnvironmentVariable('VITE_MSAL_AUTHORITY'),
        redirectUri: window.location.origin,
        navigateToLoginRequestUrl: false,
        postLogoutRedirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true,
        secureCookies: window.location.protocol === 'https:',
    },
    system: {
        allowNativeBroker: false,
        iframeHashTimeout: 10000,
        loadFrameTimeout: 10000,
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error('[MSAL]', message);
                        return;
                    case LogLevel.Info:
                        if (import.meta.env.DEV) console.debug('[MSAL]', message);
                        return;
                    case LogLevel.Verbose:
                        if (import.meta.env.DEV) console.debug('[MSAL]', message);
                        return;
                    case LogLevel.Warning:
                        console.warn('[MSAL]', message);
                        return;
                    default:
                        return;
                }
            },
            logLevel: import.meta.env.DEV ? LogLevel.Info : LogLevel.Warning,
        }
    }
};

/**
 * Add here the endpoints for protected web APIs.
 * Since we're using role-based authorization, we'll use the default scope.
 */
export const protectedResources = {
    fleetAPI: {
        endpoint: '/api/',
        scopes: [`${getEnvironmentVariable('VITE_MSAL_API_ADDRESS')}.default`],
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * We use the .default scope to get all static permissions configured on the app registration.
 */
export const loginRequest: PopupRequest = {
    scopes: protectedResources.fleetAPI.scopes,
};

export const logoutRequest: EndSessionRequest = {
    postLogoutRedirectUri: window.location.origin,
};